import Vue from 'vue'
import VueRouter from 'vue-router'
// 1.创建组件
import Login from '../components/Login'
import GysBasic from '../components/GysBasic'
import Bas_info from '../components/Bas_info'
import Operation from '../components/Operation'
import Personnel_info from '../components/Personnel_info'
import Payment_info from '../components/Payment_info'
import test1 from '../components/test1'
import GysMate from '../components/GysMate'
import Gysfcia from '../components/Gysfcia'

import GysCooPeRate from '../componentsline/GysCooPeRate'
import GysMainLine from '../componentsline/GysMainLine'
import GysTestLine from '../componentsline/GysTestLine'
import GysMateLine from '../componentsline/GysMateLine'
import ProductsCapacity from '../componentsline/ProductsCapacity'
import CompetitorcustInfo from '../componentsline/CompetitorcustInfo'

import app from 'element-ui'
Vue.use(VueRouter)

const routes = [
  {path: '/Login', component: Login, meta: {allowBack: false}},
  {path: '/GysBasic', component: GysBasic, meta: {allowBack: false}},
  {path: '/Bas_info', component: Bas_info, meta: {allowBack: false}},
  {path: '/Operation', component: Operation, meta: {allowBack: false}},
  {path: '/Personnel_info', component: Personnel_info, meta: {allowBack: false}},
  {path: '/Payment_info', component: Payment_info, meta: {allowBack: false}},
  {path: '/GysMate', component: GysMate, meta: {allowBack: false}},
  {path: '/GysCooPeRate', component: GysCooPeRate, meta: {allowBack: false}},
    {path: '/CompetitorcustInfo', component: CompetitorcustInfo, meta: {allowBack: false}},
  {path: '/ProductsCapacity', component: ProductsCapacity, meta: {allowBack: false}},
  {path: '/GysMainLine', component: GysMainLine, meta: {allowBack: false}},
  {path: '/GysTestLine', component: GysTestLine, meta: {allowBack: false}},
  {path: '/GysMateLine', component: GysMateLine, meta: {allowBack: false}},
  {path: '/gysfcia', component: Gysfcia, meta: {allowBack: false}},
  {path: '/test1', component: test1},
  {path: '*', redirect: '/Login'}
]
// 3. 创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
  routes,
  mode: 'hash', // linkActiveClass: 'is-active',//当前激活的路由的class名字
  scrollBehavior (to, from, savePotion) {
    if (savePotion) {
      return savePotion
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js